import React, { PureComponent } from "react";
import Select from "react-select";

import numeral from "numeral";

import { DropdownButton, MenuItem } from "react-bootstrap";

import { Button, ButtonGroup, Dropdown, Icon } from "aible";
import { LineInput } from "components/Inputs/LineInput";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

import { AIBLE_VIEW_TYPE, isSameSetup } from "containers/Project/reducer";

import TinyBarChart from "components/Project/TinyBarChart";
import PieChart from "components/Project/PieChart";

import ModelBoxContainer from "containers/Business/ModelBox/ModelBox";
import ModelContainer from "containers/Business/ModelBox/Model";
import ModelLabels from "components/Business/ModelBox/ModelLabels";

import ModelError from "components/Results/ModelError";

import RealityCheckContainer from "containers/Business/RealityCheck/RealityCheck";
import BusinessContainer from "containers/Business/Business";
import DatasetViewContainer from "containers/View/Dataset";
import OptimizerViewContainer from "containers/View/Optimizer";
import DeploymentViewContainer from "containers/View/Deployment";
import TaskViewContainer from "containers/View/Tasks";
import GalleryContainer from "containers/Gallery/Gallery";

import DatasetItemContainer from "containers/View/Item/DatasetItem";
import DeploymentItemContainer from "containers/View/Item/DeploymentItem";
import ProjectItemContainer from "containers/View/Item/ProjectItem";

import ProjectHelp from "containers/UnifiedProject/Help/ProjectHelp";
import ProjectHelpItem from "components/UnifiedProject/Help/ProjectHelpItem";

import MonitorWarning from "components/Consumer/MonitorWarning";

import BusinessConstraints from "containers/Business/Strategy/BusinessConstraints";

import { SegmentMetric } from "utils/optimizer/ProjectOptimizer";

import FoldersHeaderContainer from "containers/Folders/FoldersHeader";

import imageDataLight from "images/consumeHeader/data-light.svg";
import imageData from "images/consumeHeader/data.svg";
import imageModelsLight from "images/consumeHeader/models-light.svg";
import imageModels from "images/consumeHeader/models.svg";
import imageMonitoringLight from "images/consumeHeader/monitoring-light.svg";
import imageMonitoring from "images/consumeHeader/monitoring.svg";
import imageProjectLight from "images/consumeHeader/project-light.svg";
import imageProject from "images/consumeHeader/project.svg";

import { isEnabled } from "utils/featureFlags";

import styles from "./style.module.css";

export default class Consumer extends React.PureComponent {
  constructor(props) {
    super(props);

    const { setup } = this.props;

    this.state = {
      showMonitorWarning: false,
      isHammer: false,
      hideSidebar: false,
      mode: "OVERVIEW"
    };
  }

  renderMix() {
    const {
      project,
      createSplits,
      optimized,
      optimizer,
      splitOptions,
      isContinuous,
      modelGroups,
      updateDrilldownValue
    } = this.props;
    const { isCreating } = this.state;

    const drilldownValues = (modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues) || [];

    let drilldownSlice = undefined;

    for (let value of drilldownValues) {
      if (
        value.value != "Overall" &&
        (optimizer.drilldownValue == "Overall" || value.value === optimizer.drilldownValue)
      ) {
        drilldownSlice = value;
        break;
      }
    }

    const otherSlices = drilldownSlice
      ? drilldownValues.filter((v) => v && v.column && v.column == drilldownSlice.column && v.column !== "Overall")
      : undefined;

    let loadingSplits = false;

    otherSlices &&
      otherSlices.forEach((v) => {
        if (isNaN(v.optimalPct)) {
          loadingSplits = true;
        }
      });

    const darkSelectStyle = {
      option: (provided, state) => ({
        ...provided,
        background: state.isFocused ? "#512f77" : "#362e30",
        color: "white !important"
      }),
      control: (provided, state) => ({
        ...provided,
        background: "#362e44",
        border: "1px solid #828282",
        color: "white !important"
        // none of react-select's styles are passed to <Control />
      }),
      singleValue: (provided, state) => ({
        ...provided,
        color: "white"
      }),
      menuList: (provided, state) => ({
        ...provided,
        paddingTop: "0px",
        paddingBottom: "0px"
      })
    };

    const pieData = otherSlices
      ? otherSlices.map((s) => ({
          name: s.value,
          runId: s.runId,
          value: Math.round(s.optimalPct),
          color: s.color
        }))
      : [];

    return (
      <div className={styles.mixHolder} style={{ overflow: "visible" }}>
        {project && project.segments && project.segments.length === 1 && isCreating !== true ? (
          <div className={styles.splitFieldHolder}>
            <div className={styles.oItemBotHeader} style={{ textAlign: "center" }}>
              {"Split on Field"}
            </div>
            <div className={styles.splitField}>
              <Select options={splitOptions} ref="splitOne" styles={darkSelectStyle} />
            </div>
            <Button
              onClick={() => {
                this.setState({ isCreating: true });
                setTimeout(() => this.setState({ isCreating: false }), 5000);
                createSplits(
                  this.refs["splitOne"].state.value !== null ? this.refs["splitOne"].state.value.value : undefined
                );
              }}
              style={{ whiteSpace: "nowrap" }}
              isDark
            >
              {"Create Subgroups"}
            </Button>
          </div>
        ) : (!isContinuous && loadingSplits) || isCreating ? (
          <div className={styles.smallLoader} style={{ padding: "2vw" }}>
            <LoadingIndicator style={{ marginTop: "-20px" }} color={"#868595"} />
            <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Training AI Models"}</div>
          </div>
        ) : isContinuous ? (
          <React.Fragment />
        ) : pieData.find((e) => e.value) ? (
          <div>
            <div className={styles.pieHolder}>
              <PieChart
                showSegments
                pData={pieData}
                onClick={(runId, name) => updateDrilldownValue(runId, name)}
                unit={optimized.unitLabelShort}
              />
            </div>
          </div>
        ) : (
          <React.Fragment />
        )}
      </div>
    );
  }

  getBaselines() {
    const { id, setup, runId } = this.props;

    const { truePositive, falsePositive, trueNegative, falseNegative } = this.getCounts(true);

    const pursued = truePositive + falsePositive;
    const notPursued = trueNegative + falseNegative;

    const baselineTotal = pursued + notPursued;

    const bPositives = truePositive + falseNegative;
    const bNegatives = falsePositive + trueNegative;

    const baselineTotalWinRate = ((bPositives / (bPositives + bNegatives)) * 100).toFixed(2);

    return {
      baselineWinRate: baselineTotalWinRate,
      baselineTotal: baselineTotal
    };
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  renderProgress(label) {
    const { optimized } = this.props;

    return (
      <div className={styles.eLight}>
        <div className={styles.lFlex}>
          <div className={styles.eCircle} />
          {optimized && optimized.isCreating ? "Finding Optimal " + label : "Optimization Not Started"}
        </div>
        <div className={styles.eLightBar} />
      </div>
    );
  }

  // Uses subgroup counts to make overall counts if overall
  getCounts(isBaseline = false) {
    const { setup, modelGroups } = this.props;

    if (!this.getIsOverallSegment()) {
      const countsObj = isBaseline && setup.isRealityHammer && setup.baselineCounts ? setup.baselineCounts : setup;
      return {
        truePositive: Number(countsObj.truePositive),
        falsePositive: Number(countsObj.falsePositive),
        trueNegative: Number(countsObj.trueNegative),
        falseNegative: Number(countsObj.falseNegative)
      };
    }
    const retCounts = {
      truePositive: 0,
      falsePositive: 0,
      trueNegative: 0,
      falseNegative: 0
    };
    modelGroups.drilldownValues
      .filter((d) => d.value !== "Overall")
      .map((d) => d.setup)
      .forEach((currSetup) => {
        const countsObj =
          isBaseline && currSetup.isRealityHammer && currSetup.baselineCounts ? currSetup.baselineCounts : currSetup;
        retCounts.truePositive = retCounts.truePositive + Number(countsObj.truePositive);
        retCounts.falsePositive = retCounts.falsePositive + Number(countsObj.falsePositive);
        retCounts.trueNegative = retCounts.trueNegative + Number(countsObj.trueNegative);
        retCounts.falseNegative = retCounts.falseNegative + Number(countsObj.falseNegative);
      });
    return retCounts;
  }

  renderTop() {
    const {
      id,
      approvedScenario,
      isContinuous,
      getIsContinuous,
      currentSpend,
      currentRevenue,
      currentProfit,
      setup,
      isEditBlueprint,
      isBalance,
      hasLinkedProject,
      linkedProject,
      linkedProjectOutputModeOption,
      linkedProjectOutputModeOptions,
      isLoadingLink,
      optimized,
      optimizer,
      isRealityHammer,
      project,
      modelGroups,
      runId,
      model,
      projects,
      setMaxBudget,
      setMinBudget,
      updateLinkedProjectId,
      updateScaledTotal,
      updateOutcomePercentage,
      updateIsRealityHammer,
      updateHasLinkedProject,
      updateNetImpactLabel,
      updateAdvancedCostLabel,
      updateAdvancedRevenueLabel,
      updateAdvancedProfitLabel,
      updateLinkedScenarioId,
      updateLinkedProjectOutputMode,
      history,
      goToBalance,
      transactionLabel,
      truePositiveLabel,
      outcomeLabel
    } = this.props;

    const { isHammer, isCompare, isDrivers } = this.state;

    const { truePositive, falsePositive, trueNegative, falseNegative } = this.getCounts();
    const pursued = Number(truePositive) + Number(falsePositive);
    const notPursued = Number(trueNegative) + Number(falseNegative);
    const total = pursued + notPursued;

    const positives = Number(truePositive) + Number(falseNegative);
    const negatives = Number(falsePositive) + Number(trueNegative);

    const totalWinRate =
      positives + negatives !== 0
        ? ((positives / (positives + negatives)) * 100).toFixed(2)
        : setup.outcomePercentage === undefined
          ? 0
          : setup.outcomePercentage * 100;

    const minBudget =
      project &&
      project.settings.segmentMinBudgets &&
      project.settings.segmentMinBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMinBudgets[optimized.segmentId]
        : undefined;

    const maxBudget =
      project &&
      project.settings.segmentMaxBudgets &&
      project.settings.segmentMaxBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMaxBudgets[optimized.segmentId]
        : undefined;

    const isOverallSegment = this.getIsOverallSegment();

    const retIsContinuous = isContinuous || (optimized && optimized.underEstimate !== undefined);

    const mSubGroup =
      optimizer &&
      modelGroups &&
      optimizer.drilldownValue &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.value === optimizer.drilldownValue).length > 0
        ? modelGroups.drilldownValues.filter((d) => d.value === optimizer.drilldownValue)[0]
        : undefined;

    const unitType = setup.unitType !== undefined ? setup.unitType : "$";

    const isSkipped =
      approvedScenario &&
      optimized &&
      isSameSetup(approvedScenario.data, optimized.setup) &&
      setup &&
      setup.isFastTrain;

    const baselines = this.getBaselines();

    return (
      <div className={styles.emptyTop}>
        {isBalance ? (
          <div className={styles.pTitle}>{"Enterprise Resourcing Balancing & Optimization"}</div>
        ) : (
          <ProjectHelp
            title={
              isEditBlueprint
                ? "Editing Blueprint: Business Cost Benefits and Labels"
                : "Add Business Assumptions to Optimize the AI Business Impact"
            }
            isDark
            onToggle={(isClosed) => this.setState({ isHelpClosed: isClosed })}
            noBot
          >
            {isEditBlueprint !== true && (
              <ProjectHelpItem isDark type={"targetGrey"}>
                {"After Training the AI Aible will show the recommended resourcing, " +
                  "mix, and revenue that optimizes your profit and compares it to the baseline."}
              </ProjectHelpItem>
            )}
            {isEditBlueprint !== true && (
              <ProjectHelpItem isDark type={"rocketGrey"}>
                {"You will be able to keep changing these assumptions even after training the AI."}
              </ProjectHelpItem>
            )}
          </ProjectHelp>
        )}
        <div className={styles.eBoxHolder}>
          {isEditBlueprint ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>
                <LineInput
                  isMediumBox
                  isDark
                  defaultValue={
                    optimized
                      ? optimized.resourcingLabel
                      : setup && setup.resourcingLabel
                        ? setup.resourcingLabel
                        : "Resourcing"
                  }
                  onChange={(val) => {
                    updateAdvancedCostLabel(runId, val);
                    updateAdvancedCostLabel("new", val);
                  }}
                />
              </div>
              <div className={styles.eLightLarge}>{"TBD"}</div>
              <div>{"TBD"}</div>
            </div>
          ) : optimized && optimized.isCreating === false ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{optimized.resourcingLabel}</div>
              <div className={styles.eLightLarge}>
                {optimized.isCurrencyUnitType ? (
                  <div>
                    {unitType}
                    {numeral(optimized.totalCost).format("0.0a")}
                  </div>
                ) : (
                  <div className={styles.nonC}>
                    {numeral(optimized.totalCost).format("0.0a")}
                    <div className={styles.subLabel}>{unitType}</div>
                  </div>
                )}
              </div>
              {isSkipped !== true ? (
                <TinyBarChart
                  bars={[
                    {
                      label: "Optimal " + optimized.resourcingLabel,
                      Cost: optimized.totalCost
                    },
                    {
                      label: "Current " + optimized.resourcingLabel,
                      Cost: optimized.currentSpend
                    }
                  ]}
                  unit={optimized.unitLabel}
                  isCurrencyUnit={optimized.isCurrencyUnitType}
                />
              ) : (
                <div>{"Add baseline assumptions to show difference"}</div>
              )}
            </div>
          ) : optimized && optimized.isCreating ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{optimized.resourcingLabel}</div>
              <div className={styles.eLoading}>
                <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
              </div>
              {this.renderProgress("Resourcing")}
            </div>
          ) : (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{"Baseline Resourcing"}</div>
              <div className={styles.eSubDark}>
                {"This is your Business Assumptions Costs (the total cost " +
                  "per opportunity) times the Total Opportunities " +
                  "you expect to pursue."}
              </div>
              <div className={styles.eDarkLarge}>
                {unitType === "$" ? (
                  <div>
                    {unitType}
                    {numeral(currentSpend).format("0.0a")}
                  </div>
                ) : (
                  <div className={styles.nonC}>
                    {numeral(currentSpend).format("0.0a")}
                    <div className={styles.subLabel}>{unitType}</div>
                  </div>
                )}
              </div>
            </div>
          )}
          {isEditBlueprint ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{"Recommended Mix"}</div>
            </div>
          ) : optimized && optimized.isCreating === false ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{"Recommended Mix"}</div>
              {this.renderMix()}
            </div>
          ) : optimized && optimized.isCreating ? (
            <div className={styles.eBox} style={{ justifyContent: "flex-start" }}>
              <div className={styles.eDark}>{"Recommended Mix"}</div>
              <div className={styles.eLoading}>
                <LoadingIndicator
                  style={{
                    margin: "0px",
                    marginTop: "10px"
                  }}
                  color={"#868595"}
                />
              </div>
            </div>
          ) : (
            <div
              className={styles.eBox}
              style={{
                justifyContent: "flex-start",
                whiteSpace: "wrap"
              }}
            >
              <div className={styles.eDark}>{"Recommended Mix"}</div>
              <div className={styles.eSubDark}>
                {"Aible will show the optimal resource allocation once the AI has been trained."}
              </div>
            </div>
          )}
          {isBalance ? (
            <div style={{ display: "none" }} />
          ) : isEditBlueprint ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>
                <LineInput
                  isMediumBox
                  isDark
                  defaultValue={
                    optimized
                      ? optimized.revenueLabel
                      : setup && setup.advancedRevenueLabel
                        ? setup.advancedRevenueLabel
                        : "Revenue"
                  }
                  onChange={(val) => {
                    updateAdvancedRevenueLabel(runId, val);
                    updateAdvancedRevenueLabel("new", val);
                  }}
                />
              </div>
              <div className={styles.eLightLarge}>{"TBD"}</div>

              <div>{"TBD"}</div>
            </div>
          ) : optimized && optimized.isCreating === false ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{optimized.revenueLabel}</div>
              <div className={styles.eLightLarge}>
                {optimized.isCurrencyUnitType ? (
                  <div>
                    {unitType}
                    {numeral(optimized.revenue).format("0.0a")}
                  </div>
                ) : (
                  <div className={styles.nonC}>
                    {numeral(optimized.revenue).format("0.0a")}
                    <div className={styles.subLabel}>{unitType}</div>
                  </div>
                )}
              </div>
              {isSkipped !== true ? (
                <TinyBarChart
                  bars={[
                    {
                      label: "Optimal " + optimized.revenueLabel,
                      Cost: optimized.revenue
                    },
                    {
                      label: "Current " + optimized.revenueLabel,
                      Cost: optimized.currentRevenue
                    }
                  ]}
                  unit={optimized.unitLabel}
                  isCurrencyUnit={optimized.isCurrencyUnitType}
                />
              ) : (
                <div>{"Add baseline assumptions to show difference"}</div>
              )}
            </div>
          ) : optimized && optimized.isCreating ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{optimized.revenueLabel}</div>
              <div className={styles.eLoading}>
                <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
              </div>
              {this.renderProgress(optimized.revenueLabel)}
            </div>
          ) : (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{"Baseline Revenue"}</div>
              <div className={styles.eSubDark}>
                {"This uses your Business Assumption Benefits (expected revenue " +
                  "per opportunitiy) times your Total Expected Win Count."}
              </div>
              <div className={styles.eDarkLarge}>
                {unitType === "$" ? (
                  <div>
                    {unitType}
                    {numeral(currentRevenue).format("0.0a")}
                  </div>
                ) : (
                  <div className={styles.nonC}>
                    {numeral(currentRevenue).format("0.0a")}
                    <div className={styles.subLabel}>{unitType}</div>
                  </div>
                )}
              </div>
            </div>
          )}
          {isEditBlueprint ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>
                <LineInput
                  isMediumBox
                  isDark
                  defaultValue={
                    optimized ? optimized.profitLabel : setup && setup.netImpactLabel ? setup.netImpactLabel : "Profit"
                  }
                  onChange={(val) => {
                    updateNetImpactLabel(runId, val);
                    updateNetImpactLabel("new", val);
                  }}
                />
              </div>
              <div className={styles.eLightLarge}>{"TBD"}</div>
              <div>{"TBD"}</div>
            </div>
          ) : optimized && optimized.isCreating === false ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{optimized.profitLabel}</div>
              <div className={styles.eLightLarge}>
                {optimized.isCurrencyUnitType ? (
                  <div>
                    {unitType}
                    {numeral(optimized.profit).format("0.0a")}
                  </div>
                ) : (
                  <div className={styles.nonC}>
                    {numeral(optimized.profit).format("0.0a")}
                    <div className={styles.subLabel}>{unitType}</div>
                  </div>
                )}
              </div>
              {isSkipped !== true ? (
                <TinyBarChart
                  bars={[
                    {
                      label: "Optimal " + optimized.profitLabel,
                      Cost: optimized.profit
                    },
                    {
                      label: "Current " + optimized.profitLabel,
                      Cost: optimized.currentProfit
                    }
                  ]}
                  unit={optimized.unitLabel}
                  isCurrencyUnit={optimized.isCurrencyUnitType}
                />
              ) : (
                <div>{"Add baseline assumptions to show difference"}</div>
              )}
            </div>
          ) : optimized && optimized.isCreating ? (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{optimized.profitLabel}</div>
              <div className={styles.eLoading}>
                <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
              </div>
              {this.renderProgress(optimized.profitLabel)}
            </div>
          ) : (
            <div className={styles.eBox}>
              <div className={styles.eDark}>{"Baseline Profit"}</div>
              <div className={styles.eSubDark}>
                {"This is the sum of the unique businesss circumstances you defined" +
                  " in the Costs/Benefits and Expected Win Count across all" +
                  " potential opportunities."}
              </div>
              <div className={styles.eDarkLarge}>
                {unitType === "$" ? (
                  <div>
                    {unitType}
                    {numeral(currentProfit).format("0.0a")}
                  </div>
                ) : (
                  <div className={styles.nonC}>
                    {numeral(currentProfit).format("0.0a")}
                    <div className={styles.subLabel}>{unitType}</div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderOverallContent() {
    const {
      id,
      runId,
      optimized,
      isError,
      isContinuous,
      setup,
      mode,
      modelGroups,
      updateDrilldownValue,
      updateModelFeedback,
      updateBusinessMode,
      setupLabels,
      businessMode,
      primaryBusinessConstraintType
    } = this.props;

    if (optimized === undefined || optimized.isLoading) {
      return <LoadingIndicator />;
    }

    if (isError) {
      return (
        <div>
          <ModelError errors={optimized.errors} />
        </div>
      );
    }

    const costs =
      setup && setup.customValues && Object.keys(setup.customValues).length > 0
        ? Object.keys(setup.customValues)
        : [setup.truePositiveLabel, setup.falsePositiveLabel, setup.trueNegativeLabel, setup.falseNegativeLabel];

    return (
      <div className={styles.oContentWrapper}>
        {this.renderHeaderTabs()}
        <div className={styles.oContentOverall} style={{ paddingTop: "20px" }}>
          {this.renderBody()}
        </div>
        {/* JOE DO WE NEED THIS
        <div className={styles.mBox}>
          <ModelBoxContainer id={id} runId={runId} isSmall isNextStrategy />
        </div>
        */}
      </div>
    );
  }

  renderBody() {
    const {
      id,
      runId,
      optimized,
      isContinuous,
      setup,
      mode,
      modelGroups,
      updateDrilldownValue,
      updateModelFeedback,
      updateBusinessMode,
      setupLabels,
      businessMode,
      primaryBusinessConstraintType
    } = this.props;

    if (mode === "EXPAND_DETAILS") {
      return this.renderModelView();
    } else if (mode === "MONITOR") {
      return this.renderMonitoringView();
    } else {
      return this.renderOverview();
    }
  }

  renderMonitoringView() {
    const {
      id,
      runId,
      optimized,
      isContinuous,
      setup,
      mode,
      modelGroups,
      updateDrilldownValue,
      updateModelFeedback,
      updateBusinessMode,
      setupLabels,
      businessMode,
      primaryBusinessConstraintType,
      monitoringData,
      segmentId,
      compliancePlot,
      isMonitoringLoading
    } = this.props;

    if (optimized === undefined || isMonitoringLoading) {
      return <LoadingIndicator />;
    }

    const hasMonitoringData =
      monitoringData &&
      monitoringData[segmentId] &&
      monitoringData[segmentId].data &&
      monitoringData[segmentId].data.length;

    if (!hasMonitoringData && !this.state.showMonitorWarning) {
      return (
        <div className={styles.monitoringWrapper}>
          <div className={styles.monitoringBody + " " + styles.monitoringError}>
            <div className={styles.monitoringErrorTitle}>{"No Monitoring Data Found"}</div>
            <div className={styles.monitoringErrorBody}>{"There is no monitoring data for this project."}</div>
            <div className={styles.monitoringErrorBody}>
              {
                "Monitoring data is updated every 24 hours, so please check back later if you have recently made changes."
              }
            </div>
            <div className={styles.monitoringErrorBody}>
              <a onClick={() => this.setState({ showMonitorWarning: true })}>{"Show sample monitoring view"}</a>
            </div>
          </div>
        </div>
      );
    }

    return (
      <React.Fragment>
        {modelGroups && modelGroups.drilldownValues && (
          <div className={styles.leftMHolder}>
            <div className={styles.tAbs}>{"Subgroup"}</div>
            <div>
              <ModelLabels
                mode={businessMode}
                setup={setup}
                setupLabels={setupLabels}
                optimized={optimized}
                modelGroups={modelGroups}
                primaryBusinessConstraintType={primaryBusinessConstraintType}
                compliancePlot={compliancePlot}
                isMonitor
              />
            </div>
          </div>
        )}

        <div className={styles.scrollBox}>
          {modelGroups &&
            modelGroups.drilldownValues &&
            modelGroups.drilldownValues
              .filter((d) => d.column !== "Overall" || modelGroups.drilldownValues.length === 1)
              .map((d, i) => (
                <div className={styles.mHolder} key={d.runId}>
                  <ModelContainer
                    projectId={id}
                    runId={d.runId}
                    data={d}
                    mode={mode}
                    modelGroups={modelGroups}
                    model={d.bestModel}
                    optimized={optimized}
                    updateDrilldownValue={updateDrilldownValue}
                    updateModelFeedback={updateModelFeedback}
                    clickable={true}
                    setupLabels={setupLabels}
                    updateShowImpact
                    isConsumer
                    isDemo={this.state.showMonitorWarning}
                  />
                </div>
              ))}
        </div>
      </React.Fragment>
    );
  }

  renderModelView() {
    const {
      id,
      runId,
      optimized,
      isContinuous,
      setup,
      mode,
      modelGroups,
      updateDrilldownValue,
      updateModelFeedback,
      updateBusinessMode,
      setupLabels,
      businessMode,
      primaryBusinessConstraintType
    } = this.props;

    if (optimized === undefined) {
      return <LoadingIndicator />;
    }

    return (
      <React.Fragment>
        {modelGroups && modelGroups.drilldownValues && (
          <div className={styles.leftMHolder}>
            <div className={styles.tAbs}>{"Subgroup"}</div>
            <div className={styles.leftText}>
              <div className={styles.tLeft} style={{ marginTop: "65px" }}>
                {"Total Impact"}
              </div>
              <div className={styles.tLeft} style={{ marginTop: "40px" }}>
                {"Feedback"}
              </div>
              <div className={styles.tLeft} style={{ marginTop: "60px" }}>
                {"Relative Strengths"}
              </div>
              <div className={styles.tLeft} style={{ marginTop: "250px" }}>
                {"Model Drivers"}
              </div>
            </div>
          </div>
        )}

        <div className={styles.scrollBox}>
          {modelGroups &&
            modelGroups.drilldownValues &&
            modelGroups.drilldownValues
              .filter((d) => d.column !== "Overall" || modelGroups.drilldownValues.length === 1)
              .map((d, i) => (
                <div className={styles.mHolder} key={d.runId}>
                  <ModelContainer
                    projectId={id}
                    runId={d.runId}
                    data={d}
                    mode={mode}
                    modelGroups={modelGroups}
                    model={d.bestModel}
                    optimized={optimized}
                    updateDrilldownValue={updateDrilldownValue}
                    updateModelFeedback={updateModelFeedback}
                    clickable={true}
                    setupLabels={setupLabels}
                    updateShowImpact
                    isConsumer
                  />
                </div>
              ))}
        </div>
      </React.Fragment>
    );
  }

  renderOverview() {
    const {
      id,
      runId,
      optimized,
      isContinuous,
      setup,
      mode,
      modelGroups,
      updateDrilldownValue,
      updateModelFeedback,
      updateBusinessMode,
      setupLabels,
      businessMode,
      primaryBusinessConstraintType,
      allScenarios
    } = this.props;

    if (optimized === undefined) {
      return <LoadingIndicator />;
    }

    const costs =
      setup && setup.customValues && Object.keys(setup.customValues).length > 0
        ? Object.keys(setup.customValues)
        : [setup.truePositiveLabel, setup.falsePositiveLabel, setup.trueNegativeLabel, setup.falseNegativeLabel];

    const hasScenarios = allScenarios && allScenarios.length !== 0;
    return (
      <React.Fragment>
        {modelGroups && modelGroups.drilldownValues && (
          <div className={styles.leftMHolder}>
            <div className={styles.tAbs}>{"Subgroup"}</div>
            <div>
              <ModelLabels
                mode={businessMode}
                setup={setup}
                setupLabels={setupLabels}
                optimized={optimized}
                modelGroups={modelGroups}
                primaryBusinessConstraintType={primaryBusinessConstraintType}
                showFeedback={hasScenarios}
              />
              <div style={hasScenarios ? { marginTop: "35px" } : { marginTop: "18px" }} />
              {costs &&
                costs.map((c, i) => (
                  <div className={styles.aSideItem} key={i}>
                    {c}
                  </div>
                ))}
            </div>
          </div>
        )}

        <div className={styles.scrollBox}>
          {modelGroups &&
            modelGroups.drilldownValues &&
            modelGroups.drilldownValues
              .filter((d) => d.column !== "Overall" || modelGroups.drilldownValues.length === 1)
              .map((d, i) => (
                <div className={styles.mHolder} key={d.runId}>
                  {isContinuous ? (
                    <ModelBoxContainer
                      id={id}
                      runId={d.runId}
                      businessAssumptions
                      isContinuous
                      title={d.value}
                      mode={mode}
                      isMini
                      isSmall
                      isConsumer
                    />
                  ) : (
                    <ModelContainer
                      projectId={id}
                      runId={d.runId}
                      data={d}
                      mode={mode}
                      modelGroups={modelGroups}
                      model={d.bestModel}
                      optimized={optimized}
                      updateDrilldownValue={updateDrilldownValue}
                      updateModelFeedback={updateModelFeedback}
                      clickable={true}
                      setupLabels={setupLabels}
                      updateShowImpact
                      isConsumer
                      showFeedback={hasScenarios}
                    />
                  )}
                </div>
              ))}
        </div>
      </React.Fragment>
    );
  }

  renderHeaderTabs() {
    const { businessMode, updateBusinessMode, isOverallSegment, mode, primaryBusinessConstraintType, setupLabels, id } =
      this.props;

    let optimizeLabel = "Profit";
    switch (primaryBusinessConstraintType) {
      case SegmentMetric.Revenue:
        optimizeLabel = setupLabels.revenueLabel;
        break;
      case SegmentMetric.Cost:
        optimizeLabel = setupLabels.costLabel;
        break;
      case SegmentMetric.Profit:
      default:
        optimizeLabel = setupLabels.profitLabel;
    }

    return (
      <React.Fragment>
        <div className={styles.pTitle} style={{ paddingTop: "20px", marginBottom: "5px" }}>
          {mode === "MONITOR"
            ? "Impact Monitoring" + (this.state.showMonitorWarning ? " (Sample)" : "")
            : `Optimizing ${optimizeLabel}`}
        </div>
        <MonitorWarning
          show={this.state.showMonitorWarning}
          onChange={() => this.setState({ showMonitorWarning: false })}
        />
        {mode !== "MONITOR" ? (
          <div className={styles.constraintsOverview}>
            <BusinessConstraints id={id} overviewOnly />
          </div>
        ) : (
          <React.Fragment />
        )}
      </React.Fragment>
    );
    /*return (
      <React.Fragment>
        <div className={styles.headerTabs}>
          <ButtonGroup>
            <Button
              active={businessMode === "OVERVIEW" || businessMode === undefined}
              onClick={() => updateBusinessMode("OVERVIEW")}
            >
              {"Overview"}
            </Button>
            <Button
              active={businessMode === "MODEL"}
              onClick={() => updateBusinessMode("MODEL")}
            >
              {"Optimal Model"}
            </Button>
            <Button
              active={businessMode === "DETAILS"}
              onClick={() => updateBusinessMode("DETAILS")}
            >
              {"`Optimal Model Details`"}
            </Button>
          </ButtonGroup>
        </div>
        </React.Fragment>
    );*/
  }

  renderSmallTiles() {
    const { mode, id, datasetId, updateDatasetId, updateProjectId } = this.props;

    const { hideSidebar } = this.state;
    return (
      <div className={styles.sTileFlex}>
        <div className={styles.sTile + (" " + styles.sideBar + (hideSidebar ? " " + styles.hideSidebar : ""))}>
          {mode === "DATA" ? (
            <DatasetItemContainer id={datasetId} isConsumer />
          ) : mode === "MONITOR" ? (
            <DeploymentItemContainer id={id} isConsumer />
          ) : (
            <ProjectItemContainer id={id} isConsumer />
          )}
        </div>
        <div
          className={styles.smallTiles + (" " + styles.sideBar + (hideSidebar ? " " + styles.hideSidebar : ""))}
          style={mode === "DATA" || mode === "MONITOR" ? { height: "calc(100vw - 250px)" } : {}}
        >
          {this.renderFullTiles()}
        </div>
        <div className={styles.subgroupMenuFooter} onClick={() => this.setState({ hideSidebar: !hideSidebar })}>
          <Icon type={!hideSidebar ? "expandLeft" : "expandRight"} size={14} />
          {!hideSidebar ? <div className={styles.subgroupMenuFooterLabel}>{"Collapse Panel"}</div> : ""}
        </div>
      </div>
    );
  }

  renderFullTiles() {
    const { mode, id, datasetId, updateDatasetId, updateProjectId } = this.props;

    return mode === "DATA" ? (
      <DatasetViewContainer
        hideFirstTile
        hideDelete
        hDatasetId={Number(datasetId)}
        onClick={(val) => updateDatasetId(val)}
        isConsumer
      />
    ) : mode === "MONITOR" ? (
      <DeploymentViewContainer
        hideFirstTile
        hideDelete
        hProjectId={Number(id)}
        onClick={(val) => {
          this.setState({ showMonitorWarning: false });
          return updateProjectId(val);
        }}
        isConsumer
      />
    ) : (
      <OptimizerViewContainer
        hideFirstTile
        hideDelete
        hProjectId={Number(id)}
        onClick={(val) => {
          this.setState({ showMonitorWarning: false });
          return updateProjectId(val);
        }}
        isConsumer
      />
    );
  }

  renderHeaderTab(label, isActive, onClick, image) {
    return (
      <div
        className={styles.headerTabWrapper + " " + (isActive ? styles.active : "")}
        onClick={onClick}
        id={"menuTab_" + label}
      >
        {image && <Icon src={image} />}
        <div className={styles.headerTabLabel} title={label}>
          {label}
        </div>
      </div>
    );
  }

  render() {
    const {
      id,
      datasetId,
      runId,
      businessMode,
      optimized,
      mode,
      history,
      updateMode,
      isOverallSegment,
      reloadProject
    } = this.props;

    return (
      <div className={styles.pHolder}>
        <TaskViewContainer
          hideFirstTile
          hideDelete
          hProjectId={Number(id)}
          onClick={(val) => {
            this.setState({ showMonitorWarning: false });
            return updateProjectId(val);
          }}
          isConsumer
        />
      </div>
    );
  }
}
